export const TERMINAL_KINDS = ['pos', 'kds', 'expo', 'admin'] as const;
export type TerminalKind = (typeof TERMINAL_KINDS)[number];

/**
 * Terminal codes are part of the future order number `MMDD-<code>-<seq>` (owner decision T-4),
 * so they are short, uppercase and unique per location.
 */
export const TERMINAL_CODE_RE = /^[A-Z0-9]{1,3}$/;

export function isValidTerminalCode(code: string): boolean {
  return TERMINAL_CODE_RE.test(code);
}

export const TERMINAL_KIND_LABEL: Record<TerminalKind, string> = {
  pos: 'Counter POS',
  kds: 'Kitchen / Bar display',
  expo: 'Expo / Serve',
  admin: 'Admin',
};

export interface LandingInput {
  kind: TerminalKind;
  /** Code of the production route the terminal's station serves, e.g. KITCHEN or BAR. */
  stationRouteCode?: string | null;
}

/** Where an enrolled device lands after a staff member opens a terminal session. */
export function landingRouteFor(input: LandingInput): string {
  switch (input.kind) {
    case 'pos':
      return '/pos';
    case 'kds':
      return input.stationRouteCode?.toUpperCase() === 'BAR' ? '/bar' : '/kitchen';
    case 'expo':
      return '/expo';
    case 'admin':
      return '/';
  }
}
